import * as React from 'react'
import { WrappedFormUtils } from 'antd/lib/form/Form';
import { PbrSelect } from '../PbrSelect/PbrSelect';
import { Select, Row, Col } from 'antd';
import { useState, useContext } from 'react';
import { ServiceContext } from 'src/services/provider/Service.provider';
import { ShowNotification } from '../ShowNotification/ShowNotification';
import StandardButton from '../StandardButton/StandardButton';
import { IExpenseTradeItemCreate } from 'src/services/interfaces/Expense/IExpenseTradeItemCreate';
import { FilesCategoryEnum } from 'src/services/Enum/FilesCategoryEnum';
import { FileVersionEnum } from 'src/services/Enum/FileVersionEnum';
import DownloadFileButton from '../GenericButtons/DownloadFileButton/DownloadFileButton';
import { ExpenseBatchButton } from '../ExpenseBatchButton/ExpenseBatchButton';

interface IExpenseAddTradeButton2Props {
    onChange: (list: IExpenseTradeItemCreate[]) => void;
    form: WrappedFormUtils;
    tradeIds: number[];
    setLoading: React.Dispatch<React.SetStateAction<boolean>>;
    items: IExpenseTradeItemCreate[];
}

export const ExpenseAddTradeButton: React.FC<IExpenseAddTradeButton2Props> = ({
    onChange,
    form,
    tradeIds,
    setLoading,
    items
}) => {
    const { tradeSearchService } = useContext(ServiceContext);
    const [selectedTrade, setSelectedTrade] = useState<number>(undefined);

    const handleSelect = (value: number) => {
        setSelectedTrade(value);
    };

    const addTradeItem = () => {
        if (items.some((obj) => obj.tradeId === selectedTrade)) {
            ShowNotification.Warn("Trade já inserido!", "Esse trade já foi inserido, verifique em sua lista.");
        } else {
            setLoading(true);

            tradeSearchService.getTradeDetail(selectedTrade)
                .then((resp) => {
                    const newItem: IExpenseTradeItemCreate = {
                        listCategories: [],
                        tradeCpf: resp.tradeOwner.cpfCnpj,
                        tradeId: resp.id,
                        tradeName: resp.tradeOwner.fullName,
                        tradePhase: resp.phase,
                        value: resp.tradePricing?.pricing?.commission?.officer?.full?.value
                    };
                    const listItems = [...items, newItem]
                    onChange(listItems)
                })
                .catch((err) => ShowNotification.Error("Falha ao carregar trade", "Ocorreu um erro ao carregaro trade. Tente novamente."))
                .finally(() => setLoading(false));

            setSelectedTrade(null);
        }
    }

    return (
        <>
            <Row gutter={24} type="flex" align="middle">
                <Col xs={8} sm={8} md={12} lg={12} />
                <Col xs={8} sm={8} md={12} lg={12}>
                    Preencher despesas via planilha:
                </Col>
            </Row>
            <Row gutter={24} type="flex" align="middle">
                <Col xs={16} sm={16} md={4} lg={4}>
                    <PbrSelect
                        name="trade-data-options"
                        size="large"
                        formItemProps={{ label: "Trade" }}
                        formWrapper={form}
                        value={selectedTrade}
                        onChange={handleSelect}
                        placeholder="Selecione o trade"
                        showSearch
                    >
                        {!selectedTrade && <Select.Option key="" disabled value={null}>Selecione o trade</Select.Option>}
                        {tradeIds.map((id, i) => (
                            <Select.Option key={id.toString()} value={id}>{id}</Select.Option>
                        ))}
                    </PbrSelect>
                </Col>
                <Col style={{ marginTop: "16px" }} xs={8} sm={8} md={8} lg={8}>
                    <StandardButton onClick={() => addTradeItem()} disabled={!Boolean(selectedTrade)}>
                        Adicionar trade
                    </StandardButton>
                </Col>
                <Col xs={8} sm={8} md={4} lg={4}>
                    <ExpenseBatchButton items={items} onChange={onChange} setLoading={setLoading} />
                </Col>
                <Col style={{ marginTop: "10px" }} xs={16} sm={16} md={8} lg={8}>
                    <DownloadFileButton category={FilesCategoryEnum.EXPENSE_BATCH} version={FileVersionEnum.NONE} extension="xlsx" />
                </Col>
            </Row>
        </>
    );
}


// WEBPACK FOOTER //
// ./src/components/common/ExpenseAddTradeButton/ExpenseAddTradeButton.tsx